import { render, staticRenderFns } from "./dict_list.vue?vue&type=template&id=4a5c44b4&scoped=true&"
import script from "./dict_list.vue?vue&type=script&lang=js&"
export * from "./dict_list.vue?vue&type=script&lang=js&"
import style0 from "./dict_list.vue?vue&type=style&index=0&id=4a5c44b4&prod&scoped=true&lang=less&"
import style1 from "./dict_list.vue?vue&type=style&index=1&id=4a5c44b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c44b4",
  null
  
)

export default component.exports